import React, { useContext } from "react";
import { Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import styled from "styled-components/macro";
import { IconGeneric, IconMenuRUD } from "styled/Icons.styled";
import { MdDelete } from "react-icons/md";
import { RiEdit2Fill } from "react-icons/ri";
import { HiDotsHorizontal } from "react-icons/hi";
import { HrDividerNoMargin } from "styled/Line.styled";
import { AiOutlineComment } from "react-icons/ai";
import MonitoringContext from "context/MonitoringContext";
import { __DeleteFollowOrder } from "request/Monitoring/__Get_Operations";
import { useSelector } from "react-redux";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";

const MenuItemStyled = styled(MenuItem)`
  background-color: #fff !important;
  color: #000000;

  &:hover {
    background-color: #1f7ac3 !important;
    color: #fff !important;
  }
  &:hover * {
    color: #fff !important;
  }
`;

const MenuFollowOrder = ({ data, onOpen }) => {
  const token = useSelector((state) => state.auth.dataUser.token);
  const [openAlert] = AlertErrorAlert();
  const { onOpenCreateFollowOrder, setEditFollowOrder, setDeleteFollowOrder, onOpenCreateComment, setDataCreateFollowOrder } = useContext(
    MonitoringContext
  );

  const handleEdit = (e) => {
    setEditFollowOrder(data);
    onOpenCreateFollowOrder();
  };

  const handleDelete = async (e) => {
    try {
      const formData = new FormData();
      formData.append('id', data?.id)
      formData.append('status', 1)
      const res = await __DeleteFollowOrder(token, formData);
      const message = res?.data?.status?.message;
      const code = res?.data?.status?.code;
      if (code === 200) {
        setDeleteFollowOrder(true);
        openAlert(message, "success");
      } else if (code !== 200) {
        openAlert(message, "error");
      }
    } catch (error) {
      console.log(error)
    }
  };

  const handleCreateComment = () => {
    setDataCreateFollowOrder(data);
    onOpenCreateComment();
  }

  return (
    <>
      <Menu>
        <MenuButton>
          <IconGeneric as={HiDotsHorizontal} color="#00000085" />
        </MenuButton>

        <MenuList borderRadius="none" py={0} style={{ boxSizing: "border-box" }}>
          <MenuItemStyled py={3} onClick={handleEdit}>
            <IconMenuRUD as={RiEdit2Fill} />
                Editar
          </MenuItemStyled>

          <HrDividerNoMargin />
          <MenuItemStyled py={3} onClick={handleCreateComment}>
            <IconMenuRUD as={AiOutlineComment} />
                Agregar comentario
          </MenuItemStyled>
          <HrDividerNoMargin />

          <MenuItemStyled py={3} onClick={handleDelete}>
            <IconMenuRUD as={MdDelete} />
                    Eliminar
          </MenuItemStyled>
        </MenuList>
      </Menu>
    </>
  );
};

export default MenuFollowOrder;
